// --------------------------------------------------------------
// Created On: 2026-11-02
// Author: Zachary Thomas
//
// Last Modified: 2026-11-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Get the name to display for an asset, which has the nickname in parentheses after the name when one is set.
export default function getAssetDisplayName(name: string, nickname: string): string {
  if (nickname.trim() === "") {
    return name;
  }
  return `${name} (${nickname})`;
}
